import React, { useMemo } from "react";
// import { Link } from "react-router-dom";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { IconButton } from "@material-ui/core";
import { Person } from "@material-ui/icons";

export function HeaderMobile() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerLogo: uiService.getStickyLogo(),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      headerMenuSelfDisplay:
        objectPath.get(uiService.config, "header.menu.self.display") === true,
      headerMobileCssClasses: uiService.getClasses("header_mobile", true),
      headerMobileAttributes: uiService.getAttributes("header_mobile"),
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header Mobile*/}
      <div
        id="kt_header_mobile"
        className={`header-mobile align-items-center ${layoutProps.headerMobileCssClasses}`}
        {...layoutProps.headerMobileAttributes}
      >
        {/*begin::Logo*/}
        {/* <Link to="/">
          <img alt="logo" src={layoutProps.headerLogo} />
        </Link> */}
        <img alt="logo" src={toAbsoluteUrl("/media/logos/hch-logo.png")} style={{width:50, height:'auto', objectFit:'scale-down'}} />
        {/*end::Logo*/}

        {/*begin::Toolbar*/}
        <div className="d-flex align-items-center">
            <IconButton
                className="btn burger-icon-left"
                id="kt_aside_mobile_toggle"
              >
                <div>
                  <div></div>
                </div>
            </IconButton>
          {layoutProps.asideDisplay && (
            <>
              {/*begin::Aside Mobile Toggle*/}
              {/* <IconButton
                className="btn burger-icon-left"
                id="kt_aside_mobile_toggle"
              >
                <div>
                  <div></div>
                </div>
              </IconButton> */}
              {/*end::Aside Mobile Toggle*/}
            </>
          )}

          {layoutProps.headerMenuSelfDisplay && (
            <>
              {/*begin::Header Menu Mobile Toggle*/}
              {/* <button
                className="btn burger-icon ml-4"
                id="kt_header_mobile_toggle"
              >
                <div>
                  <div></div>
                </div>
              </button> */}
              {/*end::Header Menu Mobile Toggle*/}
            </>
          )}

          {/*begin::Topbar Mobile Toggle*/}
          <IconButton
            className="btn btn-hover-text-primary p-0 ml-2"
            id="kt_header_mobile_topbar_toggle"
            style={{fontSize:30, color:'white'}}
          >
            <Person />
          </IconButton>
          {/*end::Topbar Mobile Toggle*/}
        </div>
        {/*end::Toolbar*/}
      </div>
      {/*end::Header Mobile*/}
    </>
  );
}
